define('shoptheme/components/review/form',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"text!shoptheme/templates/magnific-popup/default.html",
	"magnific-popup",
	"bootstrap-rating"
], function(
	$,
	Component,
	BEM,
	PopupHtml
) {
	var _popupTemplate = null;

	return Component.create({
		block:			null,
		ratings:		null,
        submit:         null,

		$init: function() {
			this.block = BEM.block("review-form");
			this.ratings = this.block.getElements("rating");
			this.submit = this.block.getElements("submit");
			var agreementBlocks = this.block.getElements('review-agreement');

			var $tooltips = [Translator.translate('Bad'), Translator.translate('OK'), Translator.translate('Average'), Translator.translate('Good'), Translator.translate('Excellent')];
			var minValue = parseInt(this.ratings.data('min')),
                maxValue = parseInt(this.ratings.data('max'));
			this.ratings.rating({
				start: minValue - 1,
				stop:  maxValue,
                extendSymbol: function (rate) {
                    $(this).tooltip({
                        container: 'body',
                        placement: 'top',
                        title: $tooltips[rate-1]
                    });
                }
            });

			var self = this;

			$.each(agreementBlocks, function(){
				var block = BEM.block(this),
					link = block.getElements('agreement-link'),
					content = block.getElements('agreement-tooltip-inner');

				link.on('click', function(e) {
					e.preventDefault();
					e.stopPropagation();

					var title = '';
					var message = content.html();
					self._showMessage(title, message);
				});
			});
		},
		_renderPopup: function(data) {
			if (null === _popupTemplate) {
				_popupTemplate = _.template(PopupHtml);
			}
			return _popupTemplate(data);
		},
		_showMessage: function(title, message) {
			$.magnificPopup.open({
				items: {
					src: this._renderPopup({
						title: title,
						body: message
					}),
					type: 'inline'
				}
			});
		}
	});
});
